import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { debounceTime } from 'rxjs/operators';
import { Transport } from '../../../../../../models/transport.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { EstimateService } from '../../../../../../services/estimate.service';
import { TransportExtendedService } from '../../../../../../services/transport-extended.service';
import { mapAsBody } from '../../../../util/request-util';
import { OfferEstimation } from '../../../../../../models/offer-estimation.model';
import { OfferType } from '../../../../../../models/enums/offer-type.enum';

@Component({
  selector: 'jhi-modal-change-offer',
  templateUrl: './modal-change-offer.component.html',
  styleUrls: ['./modal-change-offer.component.scss'],
})
export class ModalChangeOfferComponent implements AfterViewInit {
  offerEstimations: OfferEstimation[] = [];

  @ViewChild('card') card!: ElementRef;

  @Input() transport!: Transport;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  loadingData = false;
  spinnerPriceName = 'priceRefreshing';

  debouncerRefreshPrice: Subject<string> = new Subject<string>();

  constructor(
    public modalRef: MDBModalRef,
    protected transportService: TransportExtendedService,
    protected spinnerService: NgxSpinnerService,
    protected estimateService: EstimateService
  ) {
    this.debouncerRefreshPrice.pipe(debounceTime(400)).subscribe(() => {
      this.refreshOffer();
    });
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  refreshOffer(): void {
    this.loadingData = true;
    this.spinnerService.show(this.spinnerPriceName).then();
    this.estimateService
      .estimatePricing(this.transport)
      .pipe(mapAsBody)
      .subscribe(
        offerEstimations => {
          this.offerEstimations = (offerEstimations || []).filter(offer => offer.type !== OfferType.WITHOUT_CONSTRAINTS && offer.id !== this.transport.offerId);
          this.spinnerService.hide(this.spinnerPriceName).then(() => {
            this.loadingData = false;
          });
        },
        () => {
          this.spinnerService.hide(this.spinnerPriceName).then(() => {
            this.loadingData = false;
          });
        },
        () => {
          this.spinnerService.hide(this.spinnerPriceName).then(() => {
            this.loadingData = false;
          });
        }
      );
  }

  chooseOffer(offer: OfferEstimation): void {
    this.updateTransport(offer.id);
  }

  updateTransport(offerId: number): void {
    this.transportService.applyOffer(offerId, this.transport).subscribe(transport => {
      this.modalRef.hide();
      transport.itemsNature = '';
      transport.insuranceItem = undefined;
      this.action.next(new BaryModalEvent({ submit: true, value: transport.serialize() }));
    });
  }

  ngAfterViewInit(): void {
    this.refreshOffer();
  }
}
